import { getAllSequences } from './all';
import resourceListSelectorFactory from '../utility/resourceListSelectorFactory';
import byIdSelectorFactory from '../utility/byIdSelectorFactory';
import presentation2Sequence from './2.x/sequence';

var sequence = presentation2Sequence;

export default sequence;

export var sequences = resourceListSelectorFactory(getAllSequences, sequence);

export var sequenceByIdSelector = byIdSelectorFactory(sequence, 'sequences');